module.exports = __webpack_public_path__ + "img/redis.bfe086f4.svg";